export default async url => {
  const response = await fetch(url);

  if (response.status < 200 && response.status >= 300) {
    throw new Error(response.statusText);
  }

  return response.text();
};



// WEBPACK FOOTER //
// ./src/utilities/http.js